import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { ICustomerAppsConfig } from '../config/config.module';
import { FileService } from '../file/file.service';
import { UserService } from '../user/user.service';
import { BaseUser } from '../user/models/user';

@Injectable({
  providedIn: 'root',
})
export class PrivacyService {
  private configService = inject<ConfigService<ICustomerAppsConfig>>(ConfigService<ICustomerAppsConfig>);
  private userService = inject<UserService<BaseUser>>(UserService<BaseUser>);
  private fileService = inject(FileService);

  openPrivacyPdf(): void {
    const loggedIn = this.userService.getMainUserId() !== null;
    const apiPath = this.configService.config.apiPath;
    let url: string;
    if (this.configService.config.privacyUrl !== null) {
      url = this.configService.config.privacyUrl;
    } else {
      url = loggedIn ? `${apiPath}/privacy-information` : `${apiPath}/static-privacy-information`;
    }

    this.fileService.downloadWithMeta(url).subscribe({
      next: (downloadResponse) => {
        this.fileService.openWithMeta(downloadResponse);
      },
      error: (error) => {
        console.error('Could not download privacy pdf', error);
      },
    });
  }
}
